// useRoomFiltering.tsx

import { useRoomContext } from "@/contexts/RoomContext";

export const useRoomFiltering = (hotelId: string) => {
  const { filters, actions, computed, useRooms } =
    useRoomContext();

  const roomsQuery = useRooms(
    hotelId,
    filters.currentPage,
    computed.limit,
    computed.apiFilters
  );

  const roomsData = roomsQuery.data || { data: [], total: 0 };
  const rooms = roomsData.data || [];
  const totalPages = Math.ceil((roomsData.total || 0) / computed.limit);

  return {
    rooms,
    totalPages,
    isLoading: roomsQuery.isLoading,
    error: roomsQuery.error,

    filters,
    actions,
    computed,

    pagination: {
      currentPage: filters.currentPage,
      totalPages,
      hasNextPage: filters.currentPage < totalPages,
      hasPrevPage: filters.currentPage > 1,
      goToNextPage: () => {
        if (filters.currentPage < totalPages) {
          actions.setCurrentPage(filters.currentPage + 1);
        }
      },
      goToPrevPage: () => {
        if (filters.currentPage > 1) {
          actions.setCurrentPage(filters.currentPage - 1);
        }
      },
      goToPage: (page: number) => {
        if (page >= 1 && page <= totalPages) {
          actions.setCurrentPage(page);
        }
      },
    },

    selection: {
      selectedRooms: filters.selectedRooms,
      isAllSelected:
        rooms.length > 0 && filters.selectedRooms.length === rooms.length,
      selectedCount: filters.selectedRooms.length,
      selectRoom: actions.handleSelectRoom,
      selectAll: (checked: boolean) =>
        actions.handleSelectAll(
          checked,
          rooms.map((r) => r.id)
        ),
      clearSelection: () => actions.setSelectedRooms([]),
    },
  };
};
